import React from 'react';
import ReactDOM from 'react-dom/client';
import App, { ErrorBoundary } from './App';
import { installGlobalErrorLogging } from './errorLog';

installGlobalErrorLogging();

// Polyfill window.storage backed by localStorage so data survives page reloads
window.storage = (() => {
  const ns = "humankind:";
  return {
    get: async (key) => {
      const value = localStorage.getItem(ns + key);
      return value !== null ? { key, value } : null;
    },
    set: async (key, value) => { localStorage.setItem(ns + key, value); return { key, value }; },
    delete: async (key) => { localStorage.removeItem(ns + key); return { key, deleted: true }; },
    list: async (prefix) => ({
      keys: Object.keys(localStorage)
        .filter(k => k.startsWith(ns))
        .map(k => k.slice(ns.length))
        .filter(k => !prefix || k.startsWith(prefix)),
    }),
  };
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><ErrorBoundary><App /></ErrorBoundary></React.StrictMode>);
